import { render, staticRenderFns } from "./PedidosTable.vue?vue&type=template&id=07c5d267&scoped=true&"
import script from "./PedidosTable.vue?vue&type=script&lang=js&"
export * from "./PedidosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c5d267",
  null
  
)

export default component.exports